import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { MiramisLogotype } from 'shared/domains/common-ui';
import { SIDEBAR_PADDING } from '../config';
export const SidebarMenuHeaderContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${themeGet('spacing.2xl')};
  padding: ${SIDEBAR_PADDING};
`;
export const StyledLogotype = styled(MiramisLogotype) `
  width: auto;
  height: ${pxToRem(32)};
`;
export const ToggleButton = styled.button `
  display: flex;
  border: none;
  height: ${pxToRem(32)};
  align-items: center;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
  margin: 0;
`;
